import TimeRangePicker from 'rsuite/TimeRangePicker'
import styled from "styled-components";

export const StyledTimeRangePicker = styled(TimeRangePicker)`
    width: 100%;
`